// addresses.js
const addresses = {
    pcdContractAddress: "0xEE08cB51aC98ed8d2b5EfbE794De029f9B65dC10",
    pctContractAddress: "0xE1b3d3f9302FB84C8d5B9e13cd8160fEE67Ea239",
    usdtContractaddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    pctPairContractAddress: "0xDF9549017071B88a5B9a7252f875632bfdbb7fc7",
    multiCallContractAddress: "0x3dc080adbd42d6436029d426851e0ce90e7d41da",
    authAddress: "0x6D7cAbCD5B469611ed7964FAddF3892f1D62F23A",
    proMineContractAddress: "0xD03D964d4C93FC5D0C0bEc9E7bDf3693070793B7",
    rewardAddress: "0x371a6055D50d3FbCbf9d5662144340C9E30Fc2d0",
    xpctContractAddress: "0xD0250c09799ac6d24959345d385Ae95627bB968C",
    authContractAddress: "0x6D7cAbCD5B469611ed7964FAddF3892f1D62F23A",
    adminAddress: "0x36bf226d67eb80c012ea9800f6b7ad8599190f51,0x5a32af3e7dacdf9775429c8f043dc60e195abf9f,0x0b16587d85d11a5b758fb3c8eb5be587cc9d7998,0x8bea23a0a5fced66d04644429378b54ac4e573f6",
};

module.exports = addresses;